import { gql } from '@apollo/client';

const DASHBOARD_GET_ENROLLMENT_STATUS = gql`
  query DashboardGetEnrollmentStatus($appId: ID!) {
    getEnrollmentStatus(appID: $appId)
  }
`;

export default DASHBOARD_GET_ENROLLMENT_STATUS;
